/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateAADOauthKeyInput = {|
  email?: ?string,
  issuer?: ?string,
  mobileAppUrl?: ?string,
  clientMutationId?: ?string,
|};
export type createAADOauthKeyMutationVariables = {|
  input: CreateAADOauthKeyInput
|};
export type createAADOauthKeyMutationResponse = {|
  +createAADOauthKey: ?{|
    +key: ?string,
    +AADClientId: ?string,
    +AADTenant: ?string,
  |}
|};
export type createAADOauthKeyMutation = {|
  variables: createAADOauthKeyMutationVariables,
  response: createAADOauthKeyMutationResponse,
|};
*/


/*
mutation createAADOauthKeyMutation(
  $input: CreateAADOauthKeyInput!
) {
  createAADOauthKey(input: $input) {
    key
    AADClientId
    AADTenant
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateAADOauthKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateAADOauthKeyPayload",
    "kind": "LinkedField",
    "name": "createAADOauthKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "AADClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "AADTenant",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createAADOauthKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createAADOauthKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createAADOauthKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createAADOauthKeyMutation(\n  $input: CreateAADOauthKeyInput!\n) {\n  createAADOauthKey(input: $input) {\n    key\n    AADClientId\n    AADTenant\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '568b9266eafbce3d9d29e3634a15b9fb';

module.exports = node;
